export default __webpack_public_path__ + "static/media/no-activity-found-graphics.c9a10f88.svg";